import Cards from './Cards'
import edu from '../../imgs/SVGs/skills/edu.svg'

import './About.css'

const About = () => {
  return (
    <>
      <h1>About me</h1>
      <div className="content">
        <div className='line'>
         
        </div>
        <Cards />
      </div>
    </>
  )
}

export default About